/* eslint-disable dot-notation */
import BaseComponent from 'scripts/BaseComponent.js';
import Cart from '../../cart/cart';

export default class QuickShopProductForm extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      variantIdSelect: '.js-quickShopVariantSelect',
      cardMessage: '.js-quickShopCardMessage',
      cardTitle: '.js-quickShopCardTitle',
      propertyInput: '.js-lineItemProperty',
    };

    this.dom = {
      $component: component,
      $variantIdSelect: this.$get(this.refs.variantIdSelect),
      $cardMessage: document.querySelector(this.refs.cardMessage),
      $cardTitle: document.querySelector(this.refs.cardTitle),
      $propertyInputs: this.$getAll(this.refs.propertyInput),
    };

    this.state = {
      closeQuickShopEvent: 'closequickshop',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setOnSubmit(dom.$component, this.submit);
  }

  submit() {
    const { dom, state } = this;
    const id = parseInt(dom.$variantIdSelect.value, 10);
    const { price, sku } = dom.$variantIdSelect.options[dom.$variantIdSelect.selectedIndex].dataset;
    const { productTitle } = dom.$component.dataset;
    const properties = {};

    if (dom.$cardMessage.value) {
      properties['greeting_card_style'] = dom.$cardTitle.textContent;
      properties['greeting_card_message'] = dom.$cardMessage.value;
    }

    dom.$propertyInputs.forEach((input) => {
      if (input.value) properties[input.name] = input.value;
    });

    window.dataLayer.push({
      event: 'quick_shop_submit',
      product_title: productTitle,
      variant_sku: sku,
      value: price,
    });

    this.dispatch(state.closeQuickShopEvent);
    Cart.addItem(id, properties);
  }
}
